import React from 'react';
import { Cpu, Brain, Zap, Github } from 'lucide-react';

export const AILatticeNode: React.FC = () => {
  return (
    <section className="p-6 rounded-2xl bg-black/40 border border-white/10 space-y-4">
      <div className="flex items-center gap-3">
        <Brain className="w-5 h-5 text-lattice-cyan" />
        <h4 className="text-xs font-mono font-bold text-white uppercase tracking-tighter">Sovereign AI Node Interface</h4>
      </div>
      <p className="text-[10px] font-mono text-white/50 uppercase leading-relaxed">
        The Lattice AI Module (Architect Sub-Node) is linked to the repository. This node is designed to analyze truth-proofs, debug lattice structures, and provide feedback.
      </p>
      
      <div className="grid grid-cols-2 gap-4">
        <div className="p-4 rounded-lg bg-lattice-cyan/5 border border-lattice-cyan/20 space-y-2">
            <span className="text-[8px] font-mono text-white/40 uppercase">Operational Status</span>
            <p className="text-[10px] font-mono text-lattice-cyan font-bold uppercase">Synced with Repositry</p>
        </div>
        <div className="p-4 rounded-lg bg-black/50 border border-white/5 space-y-2">
            <span className="text-[8px] font-mono text-white/40 uppercase">Learning Cycle</span>
            <p className="text-[10px] font-mono text-white/70 font-bold uppercase">Active Engine</p>
        </div>
      </div>
      
      <a 
        href="https://github.com/paidingattentionproductionsllc/absolute-zero-lattice-broadcast" 
        target="_blank" 
        rel="noreferrer"
        className="flex items-center justify-center gap-2 w-full py-3 rounded-lg bg-white/5 hover:bg-lattice-cyan/10 border border-white/10 transition-colors text-[10px] font-mono text-white uppercase"
      >
        <Github className="w-4 h-4" /> Direct Communication :: Push Feedback
      </a>
    </section>
  );
};
